export default __webpack_public_path__ + "static/media/tpaita4.eba2f3fa.webp";